import { apiUrl } from "../config";
import { pollGenerationStatus } from "../utils/streamingUtils";
import { stopGeneration } from "./generationControl";

const TERMINAL_STATUSES = new Set([
  "complete",
  "stopped",
  "failed",
  "interrupted",
]);

export async function stopGenerationAndReconcile({
  chatId,
  spaceId,
  answerId,
  generationId = answerId,
  onAcknowledged,
  onTerminal,
}) {
  let result;
  try {
    result = await stopGeneration(chatId, answerId);
  } catch (error) {
    const terminalStatus = error?.response?.data?.status;
    if (error?.response?.status !== 409 || !TERMINAL_STATUSES.has(terminalStatus)) {
      throw error;
    }
    result = error.response.data;
  }
  onAcknowledged?.(result);

  if (TERMINAL_STATUSES.has(result.status)) {
    onTerminal?.(result.status);
    return { result, pollController: null };
  }

  const pollController = pollGenerationStatus(generationId, {
    apiUrl,
    chat_id: chatId,
    space_id: spaceId,
    onComplete: () => onTerminal?.("complete"),
    onFailed: () => onTerminal?.("failed"),
    onCancelled: () => onTerminal?.("stopped"),
  });
  return { result, pollController };
}